export function BasicTemplate({
    inputData,
    colorTheme,
    pageData,
    headlineStart,
    headlineEnd
}) {
    return `<!DOCTYPE html>
    <html lang="en">
        <head>
            <meta charset="UTF-8" />
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta name="description" content="${inputData.subheading}" />
            <link rel="icon" type="image/png" sizes="32x32" href="./favicon-32x32.png">
            <link rel="icon" type="image/png" sizes="16x16" href="./favicon-16x16.png">
            <link rel="apple-touch-icon" sizes="180x180" href="./apple-touch-icon.png">
            <link rel="icon" type="image/png" sizes="512x512" href="./android-chrome-512x512.png">
            <link rel="icon" type="image/png" sizes="192x192" href="./android-chrome-192x192.png">
            <link rel="manifest" href="./site.webmanifest">
            <title>${inputData.main_headline}</title>
            <style>
                * {
                    box-sizing: border-box;
                }
                body {
                    margin: 0;
                    font-family: Arial, sans-serif;
                    color: ${inputData.primary_color};
                    background-color: #f8fafc;
                }
                a {
                    text-decoration: none;
                    color: inherit;
                }
                .container {
                    text-align: center;
                    margin: 0 auto;
                    padding: 0 24px;
                }
                header {
                    background: #fff;
                    border-bottom: 1px solid #eaeaea;
                    position: sticky;
                    top: 0;
                    z-index: 1000;
                }
                .header-inner {
                    display: flex;
                    align-items: center;
                    height: 64px;
                }
                .brand {
                    font-weight: 700;
                    font-size: 24px;
                    display: flex;
                    align-content: center;
                    align-items: center;
                }
                .hero h1 {
                    font-size: 3.5rem;
                    font-weight: 900;
                    line-height: 1.1;
                    margin-bottom: 16px;
                    color: ${inputData.primary_color};
                }
                .highlight {
                    color: ${colorTheme.accent};
                }
                .hero p {
                    max-width: 600px;
                    margin: 0 auto 40px;
                    font-size: 18px;
                    font-weight: 500;
                    color: #475569;
                }
                .button-group {
                    display: flex;
                    align-content: center;
                    justify-content: center;
                    gap: 12px;
                }
                .btn-primary {
                    background-color: ${inputData.primary_color};
                    color: white;
                    border: none;
                    padding: 14px 28px;
                    border-radius: 9999px;
                    font-weight: 600;
                    font-size: 16px;
                    cursor: pointer;
                }
                .btn-primary:hover {
                    background-color: #1e293b;
                }
                .btn-secondary {
                    background-color: white;
                    color: ${inputData.primary_color};
                    border: 1px solid #e2e8f0;
                    padding: 14px 28px;
                    border-radius: 9999px;
                    font-weight: 600;
                    font-size: 16px;
                    cursor: pointer;
                }
                .btn-secondary:hover {
                    background-color: #f1f5f9;
                }
                @media (max-width: 640px) {
                    .hero h1 {
                        font-size: 2.5rem;
                    }
                    .hero p {
                        font-size: 16px;
                    }
                    .button-group {
                        flex-direction: column;
                        gap: 10px;
                        width: 100%;
                        max-width: 280px;
                        margin: 0 auto;
                    }
                    .btn-primary, .btn-secondary {
                        width: 100%;
                    }
                }
                #modal {
                    display: none;
                    position: fixed;
                    top: 0;
                    left: 0;
                    width: 100vw;
                    height: 100vh;
                    background: rgba(0,0,0,0.5);
                    justify-content: center;
                    align-items: center;
                    z-index: 1000;
                }
                #modal div {
                    background: #fff;
                    padding: 0.8rem 2rem;
                    border-radius: 8px;
                    min-width: 300px;
                    position: relative;
                }
                input, button, select {
                    height: 40px;
                    border-radius: 1em;
                    text-align: center;
                }
                #modalChild button, #modalChild input, #modalChild select {
                    width: 100%;
                }
                button {
                    background-color: ${inputData.primary_color};
                    color: ${colorTheme.accent};
                    margin-bottom: 3px;
                }
            </style>
        </head>
        <body>
            <header>
                <div class="container header-inner">
                    <div class="brand">
                        <img alt="brand_logo" style="display: ${inputData.has_brand_logo ? "block" : "none"}" src="./android-chrome-192x192.png" width="40"/>${inputData.brand_name}
                    </div>
                </div>
            </header>
            <section class="hero">
                <div class="container">
                    <h1>
                        ${headlineStart} <span class="highlight">${headlineEnd}</span>
                    </h1>
                    <p>${inputData.subheading}</p>
                    <div class="button-group">
                        <button id="primary_button" class="btn-primary">${inputData.primary_button_text}</button>
                        <button id="secondary_button" class="btn-secondary" style="display: ${inputData.secondary_button_text ? "block" : "none"}">${inputData.secondary_button_text}</button>
                    </div>
                </div>
            </section>
            <section
                style="height: 420px;
                    margin-left: 20px;
                    margin-right: 20px;
                    margin-top: 40px;
                    background-image: url('${inputData.background_image}');
                    background-size: cover;
                    background-position: center;
                    border-radius: 16px;
                "
            ></section>
            ${pageData.map(p => `
                <section id="${p.title.toLowerCase().replaceAll(" ", "-")}" style="background-color:#f8fafc; padding:60px 20px 0; font-family: Arial, sans-serif; color:${inputData.primary_color}; text-align:center;">
                    <div style="max-width:1024px; margin:0 auto;">
                        <h2 style="font-size:2.5rem; font-weight:900; margin-bottom:12px;">${p.title}</h2>
                        <p style="font-size:1.125rem; font-weight:500; color:#475569; margin-bottom:48px;">${p.subtitle}</p>
                        <div style="display:flex; justify-content:space-between; gap:24px; flex-wrap: wrap;">
                            ${p.features.map(f => `<div style="background:#fff; border-radius:16px; padding:32px 24px; flex:1 1 300px; box-shadow: 0 2px 8px rgb(0 0 0 / 0.05); text-align:left;">
                                <div style="width:48px; height:48px; margin-bottom:20px; border-radius:12px; background: linear-gradient(135deg, ${colorTheme.accent}, ${colorTheme.warmAccent}); display:flex; align-items:center; justify-content:center; color:white; font-size:24px;">
                                    ${f.icon}
                                </div>
                                <h3 style="margin:0 0 8px 0; font-weight:700; font-size:1.25rem;">
                                    ${f.title}
                                </h3>
                                <p style="margin:0; color:#64748b; font-weight:400;">
                                    ${f.description}
                                </p>
                            </div>`).join("")}
    
                    </div>
                </div>
            </section>
            `).join("")}
            
            <section style="background-color: ${inputData.primary_color}; color: white; padding: 60px 20px; border-radius: 40px; max-width: 1024px; margin: 40px auto; text-align: center; font-family: Arial, sans-serif;">
                <h2 style="font-size: 2.5rem; font-weight: 900; margin-bottom: 16px;">${inputData.call_to_action_headline}</h2>
                <p style="font-weight: 500; font-size: 1.125rem; max-width: 500px; margin: 0 auto 32px;">
                    ${inputData.call_to_action_description}
                </p>
                <button id="cta_button" style="background: white; color: ${inputData.primary_color}; border: none; border-radius: 9999px; padding: 14px 32px; font-size: 1rem; font-weight: 600; cursor: pointer; box-shadow: 0 4px 8px rgb(0 0 0 / 0.1);">
                    ${inputData.call_to_action_button_text}
                </button>
            </section>
            <section id="modal">
                <div id="modalChild"></div>
            </section>
            <footer style="background: #f8fafc; color: #64748b; padding: 24px 20px; font-family: Arial, sans-serif; font-size: 0.875rem; max-width: 100%; margin: 0 auto; display: flex; justify-content: space-between; align-items: center;">
                <div style="font-weight: 700; font-size: 1.125rem; color: ${inputData.primary_color};">
                    ${inputData.brand_name}
                </div>
                <div>
                    &copy; ${new Date().getFullYear()} ${inputData.brand_name}. Website template by <a style="text-decoration: underline;" target="_blank"
                href="https://wendaspace.com">Wendaspace</a>
                </div>
            </footer>
            <script>
                async function postData(webhookURL) {
                    const formData = {};
                    const inputs = document.querySelectorAll('input[name^="frms_"], select[name^="frms_"]');
                    inputs.forEach(input => {
                        const inputName = input.name.replace("frms_", ""); 
                        formData[inputName] = input.value;
                    });
                    fetch(webhookURL, {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify(formData)
                    });
                }
                function submitForm(key, btnFunc) {
                    const modalDiv = document.getElementById("modalChild");
                    modalDiv.innerHTML = "";
                    const para = document.createElement("h2");
                    const input = ${JSON.stringify(inputData)};
                    para.textContent = input[key.replace("function", "text")].replace("&rarr;", "");
                    para.style.textDecoration = "underline";
                    modalDiv.appendChild(para);

                    const webhookURL = input["WebhookURL"];

                    const form = document.createElement("form");
                    form.method = "POST";
                    form.action = webhookURL;

                    for (const f of btnFunc) {
                        const wrapper = document.createElement("div");
                        const label = document.createElement("label");
                        label.textContent = f.label + ": ";
                        wrapper.appendChild(label);

                        if (f.type === "options") {
                            const select = document.createElement("select");
                            select.name = "frms_" + f.label;
                            const options = f.options.split(",");
                            for (const opt of options) {
                                const option = document.createElement("option");
                                option.value = opt;
                                option.textContent = opt;
                                select.appendChild(option);
                            }
                            wrapper.appendChild(select);
                        }
                        else {
                            const input = document.createElement("input");
                            input.type = f.type || "text";
                            input.name = "frms_" + f.label;

                            wrapper.appendChild(input);
                        }

                        form.appendChild(wrapper);
                    }
                    const btn = document.createElement("button");
                    btn.textContent = "Submit";
                    btn.type = "submit";

                    form.appendChild(btn);
                    const closeBtn = document.createElement("button");
                    closeBtn.textContent = "Close";
                    closeBtn.style.backgroundColor = "${inputData.secondary_color}";
                    closeBtn.style.color = "#333";
                    closeBtn.type = "button";
                    closeBtn.addEventListener("click", function () {
                        document.getElementById("modal").style.display = "none";
                    });

                    form.appendChild(closeBtn);
                    modalDiv.appendChild(form);
                    document.getElementById("modal").style.display = "flex";
                }

                function redirectUrl(url) {
                    window.open(url, "_blank", "noopener,noreferrer");
                }

                function scrollToSection(id) {
                    const section = document.getElementById(id);
                    if (section) {
                        section.scrollIntoView({ behavior: "smooth" });
                    }
                }

                const buttonConfigs = [
                    { id: "primary_button", key: "primary_button_function" },
                    { id: "secondary_button", key: "secondary_button_function" },
                    { id: "cta_button", key: "primary_button_function" },
                ];

                for (const b of buttonConfigs) {
                    const button = document.getElementById(b.id);
                    if (!button) continue;
                    const input = ${JSON.stringify(inputData)};
                    const btnFunction = input[b.key];
                    button.addEventListener("click", () => {
                        if (btnFunction?.[0]?.value) {
                            const val = btnFunction[0].value;
                            if(val.includes("#")) {
                                scrollToSection(val.replace("#", ""));
                            }
                            else {
                                redirectUrl(val);
                            }
                        } else {
                            submitForm(b.key, btnFunction);
                        }
                    });
                }
            </script>
        </body>
    </html>`;
}